module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "introduction",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('b', [_vm._v("Introduction")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("“For much of the happiness, or absence of misery, with which I passed this year, I am indebted to the genial temper and ardent friendship of my brother slaves. They were every one of them manly, generous, and brave; yes, I say they were brave, and I will add fine looking. It is seldom the lot of any to have truer and better friends than were the slaves on this farm. It was not uncommon to charge slaves with great treachery toward each other, but I must say I never loved, esteemed, or confided in men more than I did in these. They were as true as steel, and no band of brothers could be more loving. There were no mean advantages taken of each other, no tattling, no giving each other bad names to Mr. Freeland, and no elevating one at the expense of the other. We never undertook anything of any importance which was likely to affect each other, without mutual consultation. We were generally a unit, and moved together.”")]), _c('a', {
    attrs: {
      "id": "rinten1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" With these words, Frederick Douglass, one of the most celebrated black men in American history, described the men he had lived and worked with while enslaved in Maryland in 1835. Trapped in a world of brutal physical punishment, unremitting back-breaking labor, and forced separation from loved ones, Douglass testified that the friendship he shared with other enslaved men carried him through his dark days of enslavement. These men were central to Douglass; their friendship eased the pain of slavery. It was to this circle of men that he turned for emotional comfort. He affirmed the masculinity of his friends and pronounced that their lives were interdependent. They were a “unit” and “moved together.” They were a “band of brothers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Douglass’s musings are insightful because they shed light on an intimate area of enslaved life: enslaved men and their relationships with other men. Yet, in contrast to studies of enslaved women and gender, works on enslaved men and issues of masculinity have proved less forthcoming because historians have generally failed to employ the techniques of gender history to analyze the lives of enslaved men. Only recently have scholarly articles begun to examine how enslaved men negotiated masculine identities "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("under slavery.")]), _c('a', {
    attrs: {
      "id": "rinten2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The lack of focus on enslaved men and masculinity contrasts markedly with the plethora of monographs recently published on white masculinity in the antebellum South. By exploring the lives of men and using masculinity as a category of analysis, these works have considerably deepened our knowledge of the unique social and cultural worlds of the antebellum American South."), _c('a', {
    attrs: {
      "id": "rinten3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" However, our knowledge of African American men and issues of masculinity in the antebellum South remains considerably underdeveloped. Fundamental questions persist: How did enslaved men construct masculine identities while living under an emasculating institution? How did they relate to one another? Who were their friends? How significant were these relationships in their lives? These are just some of the questions addressed in "), _c('i', [_vm._v("My Brother Slaves: Friendship, Masculinity, and Resistance in the Antebellum South")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Provider/Protector Masculinity")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the issue of slave masculinity has been discussed in studies of American slavery, it has usually been considered as part of a wider discussion of the slave family. In 1939, sociologist E. Franklin Frazier argued that the slave family was “matrifocal.” Enslaved fathers and husbands were deprived of their masculine authority as a result of the sexual exploitation of enslaved women, the sale and separation of families, the illegality of marriage for slaves, and the overarching power of the master. Furthermore, because in the American South the legal status of children followed that of their mothers, men’s authority was further undermined."), _c('a', {
    attrs: {
      "id": "rinten4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Frazier’s thesis was supported in the 1950s by historians Kenneth Stampp and Stanley Elkins, who both contended that, unable to provide and protect their families, enslaved men were emasculated. Stampp emphasized the victimization of enslaved people, arguing that the enslaved were condemned to live “in a kind of cultural chaos.” For enslaved men, he argued, the family did not have the same social importance that it had in the life of a white man. The husband “was not the head of the family, the holder of property, the provider, or the protector.” In a patriarchal age, the enslaved male’s only vital function was producing children; accordingly, the slave family was matriarchal."), _c('a', {
    attrs: {
      "id": "rinten5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Elkins, too, asserted that the slave father was “virtually without authority over his child, since discipline, parental responsibility, and control of rewards and punishments all rested in other hands.” He continued:")]), _vm._v(" "), _c('p', {
    staticClass: "quotet"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The slave father could not even protect the mother of his children except by appealing directly to the master. Indeed, the mother’s role loomed far larger for the slave child than did that of the father. She controlled those few activities—household care, preparation of food, and rearing of children—that were left to the slave family. For that matter, the very etiquette of plantation life removed even the honorific attributes of fatherhood from the Negro male, who was addressed as “boy”—until, when the vigorous years of his prime were past, he was allowed to assume the title of “uncle.”")]), _c('a', {
    attrs: {
      "id": "rinten6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The publication, in 1965, of Daniel Moynihan’s government-funded report, "), _c('i', [_vm._v("The Negro Family: The Case for National Action")]), _vm._v(", developed the findings of Frazier, Stampp, and Elkins. In his report, Moynihan traced the origins of African American family breakdown back to slavery. The contemporary African American family, he argued, was trapped in a “tangle of pathology” because it had been “forced into a matriarchal structure,” which imposed a “crushing burden on the Negro male.” African American men felt insufficient performing the roles of husband and father and deserted families accordingly. In Moynihan’s view, the emasculating slave-rooted matriarchal family arrangement continued to persist after slavery."), _c('a', {
    attrs: {
      "id": "rinten7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In response to the Moynihan report and the likes of Stampp and Elkins, historians of the 1970s vehemently attacked the matriarchy thesis. Shaped by the civil rights movement and the “new social history,” which set out to write history “from the bottom up,” historians writing during this period, such as Herbert Gutman, Eugene Genovese, and John Blassingame, maintained that slavery did not necessarily destroy the family life of enslaved people. Indeed, the slave family, they claimed, served as an important buffer protecting enslaved people from the worst abuses of the slave system. Most slave children, argued Herbert Gutman, lived with two parents, and most adults enjoyed long-lasting marriages."), _c('a', {
    attrs: {
      "id": "rinten8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Gutman reassessed the role of the male in the slave family and identified patrilineal slave-naming practices, which, in his view, indicated the importance of the father and strengthened family ties."), _c('a', {
    attrs: {
      "id": "rinten9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Genovese concurred with Gutman that the enslaved, despite considerable constraints, valued a “two-parent, male-centered household.” He opened his chapter entitled “The Myth of the Absent Family” by attacking the “conventional wisdom according to which slavery had emasculated black men, created a matriarchy, and prevented the emergence of a strong sense of family.” Many enslaved men, argued Genovese, despite "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("the emasculating effects of slavery, acted as providers and protectors.")]), _c('a', {
    attrs: {
      "id": "rinten10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Similarly for Blassingame, although his authority was curtailed, the enslaved father and husband still played pivotal roles in family life, providing extra food, building furnishings, and bringing up children."), _c('a', {
    attrs: {
      "id": "rinten11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, by the early 1980s, some historians voiced concerns that these revisionist historians, by emphasizing the vitality of a slave community and the strength of the slave family, were in danger of creating a “utopian slave community.”"), _c('a', {
    attrs: {
      "id": "rinten12"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Deborah Gray White maintained that slave families were matrifocal. Enslaved women, she argued, could not depend on their husbands’ protection against punishments, such as whipping or sexual exploitation. Additionally, enslaved men were generally unable to provide women with food, clothing, and shelter and were thus denied “this exercise of authority.”"), _c('a', {
    attrs: {
      "id": "rinten13"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" A decade later, sociologist Orlando Patterson published a scathing critique of the revisionist historians, claiming that slavery was “most virulent in its devastation of the roles of father and husband.”"), _c('a', {
    attrs: {
      "id": "rinten14"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Echoing Moynihan, he argued that the contemporary African American community was facing a crisis in gender relations, with 60 percent of African American children raised without the material or emotional support of a father. Patterson traced these problems back to slavery and posed the following questions:")]), _vm._v(" "), _c('p', {
    staticClass: "quotet"
  }, [_vm._v("Could he monopolize his partner’s sexual services and guarantee that her progeny were in fact his own? Could he protect her from the sexual predation of other men? Could he at least partly provide for her materially? Could he prevent her from being brutalized and physically punished by other men? Could he prevent her from being torn from the place where she was brought up, bundled like cargo, and sold away from him, her children, her kinsmen, and her friends? If the answer to any of these questions is “No,” the role of the husband did not exist. If the slave could do none of these things, then the role of the husband had been devastated."), _c('a', {
    attrs: {
      "id": "rinten15"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("More recently, Wilma Dunaway criticized the likes of Gutman and Genovese, whose generalizations about the stability of the slave family, she claimed, “sound more like a Disney script than scholarly research.”"), _c('a', {
    attrs: {
      "id": "rinten16"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Dunaway’s research contended that the majority of slave holdings in the Appalachian region were small plantations (Gutman’s and Genovese’s studies had focused on large plantations of the Deep South). In Dunaway’s view, "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("slave families on small plantations were more prone to slave sales, received more manipulation from the owner, and were more likely to be headed by one parent. Other regional studies, similarly, have emphasized that slave families were devastated and, therefore, the familial role and masculine authority of enslaved men were severely undermined.")]), _c('a', {
    attrs: {
      "id": "rinten17"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recently, however, Emily West has refuted the counter-revisionist argument that slave families and the masculine role of enslaved men were significantly weakened. Even when enslaved couples were separated, many maintained cross-plantation marriages, which, in West’s opinion, were “far from weak and nominal relationships.” In South Carolina, the region of West’s study, cross-plantation marriages accounted for 33.5 percent of all slave marriages, alongside nuclear marriages, calculated at 46.2 percent."), _c('a', {
    attrs: {
      "id": "rinten18"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" In cross-plantation marriages, “it was men, not women, who saw it as their duty to undertake visits, and this role-adoption suggests wider conclusions—that male slaves, despite living under oppression, saw themselves as initiators, protectors, and providers.”"), _c('a', {
    attrs: {
      "id": "rinten19"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Similarly, Rebecca Fraser has contended that pursing courtships off the plantation enabled enslaved men to “enhance their own sense of masculine identity and resist the negative gender characteristics that had been imposed upon them in the context of slavery.”"), _c('a', {
    attrs: {
      "id": "rinten20"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The enslaved men of Fraser’s study performed extra labor in return for cash, worked garden patches, and hunted to provide resources for their families. Her work also demonstrated that while women could not rely on their male partners for protection against punishment, there were occasions when enslaved men took whippings for their wives or girlfriends and for women they wished to court, with whom they had no established familial or affectionate ties. These men, accordingly, enhanced their own sense of masculine identity, adopting the role of “protector” while also defending the femininity of enslaved women—something these women would have been further stripped of had they received whippings."), _c('a', {
    attrs: {
      "id": "rinten21"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("The Homosocial World of Enslaved Men")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In these historiographical debates, when historians have discussed notions of enslaved masculinity, they have almost always framed their analyses within the context of courtship, marriage, and family life. Masculinity, in these works, is equated with the ability to provide and protect—establishing familial authority and responsibility. For men in antebellum America, these were certainly hallmarks of masculinity."), _c('a', {
    attrs: {
      "id": "rinten22"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Indeed, anthropologists, "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("sociologists, and historians agree that in most societies, establishing and heading a family is the vital purpose of masculinity.")]), _c('a', {
    attrs: {
      "id": "rinten23"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" However, as scholar Michael Kimmel has noted, “in large part, it’s other men who are important to American men; American men define their masculinity, not as much in relation to women, but in relation to each other.” Indeed, he stated that “masculinity is largely a homosocial enactment.” It is performed for and judged by other men."), _c('a', {
    attrs: {
      "id": "rinten24"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" David D. Gilmore, in his cross-cultural anthropological study of masculinity, contended that for most males, manhood is a “critical threshold” that must be passed through “testing.” Gilmore found that as well as protecting and providing for their families, various exploits—such as boyhood rituals, feats of risk-taking, and heavy drinking—were key ways men crafted masculine identities in all-male environments. In this way, masculinity is a test—something that has to be proved in the company of one’s peers."), _c('a', {
    attrs: {
      "id": "rinten25"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Anthropologist and feminist scholar Michelle Rosaldo similarly argued that for a boy to become a man, “he must prove himself—his masculinity—among his peers.”"), _c('a', {
    attrs: {
      "id": "rinten26"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was particularly the case in the antebellum South, where masculinity was a social designation that required testing and confirmation in public in the presence of other men. Among elite southern whites, for example, a boy became a man when he proved to his community that he was one."), _c('a', {
    attrs: {
      "id": "rinten27"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Bertram Wyatt-Brown’s groundbreaking work on southern honor demonstrated that a white man’s identity in the Old South was decided among “the "), _c('i', [_vm._v("deme")]), _vm._v(" or larger ‘family’ of peers and superiors called community.” Southern men were governed by a code of honor, a set of ethical rules by which “judgements of behavior are ratified by community consensus.”"), _c('a', {
    attrs: {
      "id": "rinten28"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" A southern man was not regarded as manly unless he was honorable, but this required demonstrating, and the judgment could only be bestowed upon him by his fellow peers. Men demonstrated and validated their masculinity through family and work but also through recreational pursuits. Southern men prized activities such as drinking, gambling, hunting, and fighting. They enjoyed these exploits in homosocial spaces. Here, they displayed physical prowess, daring, and a capacity to drink. They competed for recognition, honor, and respect and affirmed social ties accordingly; they dramatized their masculinity in the presence of other men and, in the process, created an all-male subculture."), _c('a', {
    attrs: {
      "id": "rinten29"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men, too, created an all-male subculture in the antebellum South. "), _c('i', [_vm._v("My Brother Slaves:")]), _vm._v(" reveals that, similar to southern whites, enslaved men engaged in homosocial recreational pursuits such as drinking, "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("gambling, wrestling, and hunting. These activities were extremely important for enslaved men, yet historians have failed to analyze their gendered implications. In slave communities, men claimed these activities as masculine preserves. It was here, in an all-male world, they constructed markers of status, identity, and masculinity and forged lasting friendships. It was here, together, that they fought the humiliating, degrading, and emasculating features of their enslavement. In this homosocial world, they became men.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The arguments presented here owe much to the immense advances made in the past three decades by historians researching gender and the lives of enslaved women.")]), _c('a', {
    attrs: {
      "id": "rinten30"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Deborah G. White pioneered this approach in slave studies, placing the lifecycle, family, labor, and social life of enslaved women at the center of analysis. The impact of White’s work is still being felt today, with many historians using gender as a category of analysis to examine the lives of enslaved women to great effect and, in the process, emphasizing the many important nuances of slave life. These studies continue to teach historians of slavery that gender was central to defining the experiences of enslaved men and women and that gender rarely operated independently of race and class. Rather, it was constitutive of the class and racial hierarchies that shaped the system of slavery in the American South and thus served as “a primary way of signifying relationships of power.”"), _c('a', {
    attrs: {
      "id": "rinten31"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the key tenets of Deborah G. White’s thesis was that enslaved women functioned in groups; cooperation and interdependence characterized adult female life. For much of the day, enslaved women were in each other’s company: on large plantations they worked in sex-segregated gangs together, socialized together, supported one another during childbirth, shared childcare responsibilities, and passed skills down from one generation to the next. White termed this interdependence the “female slave network.” She claimed it was perhaps easier for enslaved women to maintain significant emotional relationships with other enslaved women than with enslaved men. Male-female relationships were not unfulfilling, or of no consequence, but they faced considerable uncertainty as a result of cross-plantation marriages, and the daily threat of sale—both of which added to the independence of women from their spouses. When men were not readily present to rely on, women turned to one another for daily emotional and practical support. The female network was always there, between a husband’s weekly visits from another plantation and when a husband or son was sold off or ran away. As a result, female solidarity increased and "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("women forged strong friendships. The female slave network was integral to enslaved women’s understanding of femininity: through each other, White claimed, enslaved women could “forge their own independent definition of womanhood.” The company of other women “sustained” female slaves during their enslavement. “Few women … survived without friends, without female company.”")]), _c('a', {
    attrs: {
      "id": "rinten32"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("White’s insights can certainly help shed light on the homosocial world of enslaved men. Indeed, as White reflected, if enslaved women cooperated with one another and functioned in groups, “odds are that the same can be said of men.”"), _c('a', {
    attrs: {
      "id": "rinten33"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The current volume develops White’s framework to explore the homosocial world and friendships of enslaved men. The experiences of enslaved men and women were in many ways distinct from each other. Like those of the female slaves of White’s study, the lives of enslaved men were interconnected. Across the antebellum South, male group cooperation and interdependence characterized everyday life for many enslaved men. This book’s central objective is the examination of a male homosocial network. On large plantations, men labored together in sex-segregated work gangs; those employed in industry lived and worked in a distinct homosocial world cut off from regular plantation life. The book explores how enslaved men, in such environments, fashioned their own unique masculine work culture. It pays attention, too, to the social spaces occupied by enslaved men. Many men drank, gambled, and wrestled in all-male settings. At night, during the week, and at weekends, they teamed up to evade the white patrol gangs who policed their plantations’ boundaries in order to visit loved ones on different plantations. The book underscores the centrality and importance of such activities in the lives of many enslaved men. Through these pursuits, they negotiated distinct masculine identities; they performed, witnessed, and assessed masculine behavior and affirmed social ties. In these spaces, they formed lifelong, meaningful friendships. Borrowing White’s terminology, enslaved men created their own male slave network.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Resistance is a second theme of this book; resistance to slavery was not always direct and overt, and it manifested itself in nuanced ways. Historians have paid a great deal attention to slave revolts, quite rare in the American South, which were mostly organized by men. In 1829, free black abolitionist David Walker, in his "), _c('i', [_vm._v("Appeal to the Colored Citizens of the World")]), _vm._v(", urged enslaved men to rise up and rebel against their white oppressors. The masculine implications of his message were explicit: “You have to prove to the Americans and the world, that we are MEN, and not brutes.” “When "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("shall we arise from this death-like apathy?—And be men!!”")]), _c('a', {
    attrs: {
      "id": "rinten34"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" He equated manhood with heroic rebellion and freedom. A number of African American writers of the nineteenth century, as well as subsequent scholars, have equated slave rebellion with masculinity. In this way, only those who defiantly and violently challenged their enslavement proved their masculinity. This approach, however, is unhelpful, for it implies that those men who did not violently rebel somehow lacked masculinity."), _c('a', {
    attrs: {
      "id": "rinten35"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('i', [_vm._v("My Brother Slaves")]), _vm._v(" reconceptualizes male resistance to slavery by shifting attention from the visible, organized, collective world of slave rebellion to the intimate, hidden, and private world of enslaved men."), _c('a', {
    attrs: {
      "id": "rinten36"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" It was in their everyday spaces that enslaved men developed their male subculture and negotiated their masculinity. Denied the opportunity of open, organized political and public expression, they turned to everyday forms of resistance, “hidden transcripts,” in order to contest the public transcript of power relations."), _c('a', {
    attrs: {
      "id": "rinten37"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Every day, men fought over their personal lives and gendered identity, often in defiance of the spatial and temporal regulations that governed their lives. Covertly, against their masters’ will, they left the plantations at night to meet up with one another to share a drink, gamble, and organize wrestling matches. Enslaved men risked their lives, too, evading and sometimes fighting the patrol gangs when they left the plantation without permission and traversed into these forbidden spaces. Men also regularly used their contacts with other men to spread subversive news, gossip, and rumors from plantation to plantation. Moreover, they used their links with one another to harbor and assist runaways. The book probes the intimate friendships established by enslaved men. Friendship framed, shaped, and gave meaning to the homosocial relationships of enslaved men. Moreover, it served as a vital coping mechanism to endure the brutalizing characteristics of slavery; few men could survive slavery without friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third focus of this study is a response to recent calls from historians to link the everyday world of enslaved people to the overt, collective, rebellious struggles waged by the likes of Gabriel Prosser, Denmark Vesey, and Nat Turner. As Walter Johnson has declared in studies of slavery, the terms “everyday” and “revolutionary” have “been allowed for too long to stand in unproductive opposition to one another rather than being thought of as dialectically inter-related.” He posed a series of questions for historians: “How, we might ask, did enslaved people set about forming social solidarities and political movements at the scale of everyday life? How did they talk to one another about slavery, resistance, and revolution? How did they "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("sort through which of their fellows they could trust and which they could not?”")]), _c('a', {
    attrs: {
      "id": "rinten38"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('i', [_vm._v("My Brother Slaves")]), _vm._v(" addresses Johnson’s questions. Through friendship, enslaved men met, grumbled to one another, plotted rebellion, and ran away. In the private, everyday world of friendship, enslaved men formulated their politics. These friendships grew out of the solidarities affirmed among men on a day-to-day basis. The routine mobility of these enslaved men and the cross-plantation contacts they maintained with one another through the course of their social activities facilitated the collective coordination of resistance across plantations. The book dissolves dichotomies, such as personal/political and everyday resistance/organized rebellion, and argues that we cannot fully explore the complexity of slavery in an either/or framework."), _c('a', {
    attrs: {
      "id": "rinten39"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One area of enslaved life that this book does not cover is homosexuality. Formerly enslaved people did not discuss the subject in their recollections of slavery; indeed, one of the problems confronting historians studying homosexuality in western society is that until fairly recently, most homosexual people in history did not speak openly about their sexuality because in doing so they risked social ruin. Often, the law, religion, and medicine stigmatized homosexuality; accordingly, people concealed their sexual identities, leaving few sources behind for historians."), _c('a', {
    attrs: {
      "id": "rinten40"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" We can only speculate that such relationships existed among enslaved men, as they have done in all human societies. Certainly, some of the friendships shared among enslaved men were intense; however, without evidence, it is simply impossible to shed light on the lives of gay male slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This project utilizes a variety of different source materials to examine the world of enslaved men—in particular, the testimony of enslaved people. Between 1936 and 1938, the Federal Writers Project of the Works Progress Administration (WPA) collected thousands of interviews from former slaves across seventeen states. These were first made available in 1972, as publication of George Rawick’s eventual forty-one-volume work "), _c('i', [_vm._v("The American Slave")]), _vm._v(" began. There has been considerable debate concerning the use of the WPA narratives in studies of slavery. Some scholars have drawn attention to the power relations between white southern interviewers and former slaves, which allegedly influenced the latter’s responses. John Blassingame has stressed that African American vulnerability to white oppression was “painfully "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("evident” in the Depression South, where more than seventy lynchings occurred between 1931 and 1935. Additionally, it was not uncommon for formerly enslaved people to remain resident in the same areas as their masters’ descendants. These former slaves were dependent on whites in order to claim their pensions, and, consequently, they sometimes responded to questions with flattery and embellishment to gain the approval of their interviewers. In such a climate, interviewers adopted racist and paternalistic lines of questioning, transcribing the records of their meetings accordingly. Some interviewers also heavily edited their narratives, altering, or censoring their accounts. Blassingame argues that the former slaves who talked to black interviewers in the Fisk University interviews, conducted a few years earlier, revealed a different picture of slavery than those interviewed by the all-white team of the South Carolina WPA project.")]), _c('a', {
    attrs: {
      "id": "rinten41"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Age is another factor to consider. Ex-slaves were interviewed seventy or eighty years after their experiences of slavery; two-thirds of the respondents were more than eighty years old. Some scholars, therefore, have questioned the accuracy of such recollections, claiming that the interviewees’ long-term memories were suspect."), _c('a', {
    attrs: {
      "id": "rinten42"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Moreover, because the interviews were conducted in the 1930s, many of the informants only experienced enslavement as children or adolescents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, evidence from the narratives clearly shows that former slaves were willing to discuss stories that were hardly flattering to white interviewers. As Edward E. Baptist has noted, “some ex-slaves were directly confrontational.” Indeed, as many of these elderly former slaves neared the ends of their lives, there was little left to lose, and, for some, those years “became the peak of moral courage.” According to Baptist, the interviewer’s race did not necessarily change the responses from former slaves—the narratives of Virginia, where most interviewers were black, resembled those from Texas, where most were white."), _c('a', {
    attrs: {
      "id": "rinten43"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" If former slaves were reluctant to discuss certain things, these were sensitive subjects such as sexual abuse and other personal matters, particularly when women were interviewed by men."), _c('a', {
    attrs: {
      "id": "rinten44"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Furthermore, evidence shows that certain lines of questioning were not necessarily affected by the race of the interviewer."), _c('a', {
    attrs: {
      "id": "rinten45"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Regarding editing, it is worth mentioning that in 1977 and 1979, Rawick, with Jan Hillegas and Ken Lawrence, published twenty-two narratives in two supplementary series to "), _c('i', [_vm._v("The American Slave")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "rinten46"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" These had been collected as part of the WPA project but were not sent to Washington, DC, and instead remained in various state archives and depositories. In these archives, Rawick and his "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("team of researchers also found unedited versions of narratives that had been sent to the Writers’ Project. Rawick explained their withholding, claiming that, for example, the Mississippi collection, was most likely “too hot to handle.” Indeed, according to some historians, the Mississippi interviews sent to Washington offer a more “consensual” portrayal of slavery than those that remained in the Mississippi archives.")]), _c('a', {
    attrs: {
      "id": "rinten47"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Many of the sources used in this book draw on Rawick’s supplementary series. Finally, on the subject of age, historian Paul Escott has emphasized that recent studies “have shown that aging does not impair the recollection of the elderly, despite society’s common assumption that it does.” In fact, argues Escott, intellect actually improves with age. People are more likely to recall events at critical junctures in their lives, such as wedding days, graduation, and birth and deaths in modern America; for former slaves, then, events such as their day of emancipation or the sale of a relative would almost certainly remain vivid in their minds."), _c('a', {
    attrs: {
      "id": "rinten48"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Moreover, although many narratives are childhood memories and concern stories that had been told and retold by family and friends, it is important to remember the strong oral tradition that existed among African American communities in the aftermath of emancipation. Forbidden to learn to read or write, members of these communities placed much more importance on the spoken word and the ability to recount a story with purpose and depth."), _c('a', {
    attrs: {
      "id": "rinten49"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For historians, the WPA narratives are an immensely rich source. Indeed, they have revolutionized slavery studies. Before the publication of the narratives, studies relied mostly on travel accounts from northerners and European whites and on slaveholder plantation records. Accordingly, historians, relying on these white sources, cast enslaved people in submissive and passive roles—perhaps best embodied by the humble and docile “Sambo” stereotype."), _c('a', {
    attrs: {
      "id": "rinten50"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" In contrast, historians in the 1970s, using these narratives for the first time, were able to view slaves as active subjects in their own right. The WPA narratives provide historians with firsthand accounts from exslaves on a range of personal subjects, including courtship, family, religion, culture, punishment, and resistance. They allow historians to enter the private world of enslaved people. They give enslaved people agency. This book, therefore, makes extensive use of these invaluable sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("My Brother Slaves")]), _vm._v(" also uses autobiographies penned by formerly enslaved people who chronicled their experiences of slavery. Between 1760 and 1947, more than two hundred American slave autobiographies were published. These can generally be divided into three kinds. Those published from "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("the 1770s to the 1820s are usually narrated as spiritual journeys by authors who considered themselves Africans, not slaves. From the 1820s through to the Civil War period, the slave narrative evolved into a distinct autobiographical genre highlighting the horrors of slavery to further the abolitionist cause. These narratives usually describe slave auctions, slave sales, the separation of family members, brutal punishments, and eventual escape to the North; they were characteristically sensationalist, and many were promoted, edited, and distributed by abolitionists. After the Civil War, the narratives changed tone. Losing their urgency, they became less devoted to depicting the horrors of slavery, with many becoming nostalgic and written as a sentimental reaffirmation of plantation life. These usually end with the author’s adjustment to freedom.")]), _c('a', {
    attrs: {
      "id": "rinten51"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The slave autobiographies are not without their problems. Many of the antebellum ones were narrated by literate mulattos and house slaves, and the vast majority of these fugitive slaves were enslaved near the Mason-Dixon Line, as opposed to the Deep South. This inevitably raises the issue of how representative these accounts were of typical rank-and-file slaves. These slaves, who had managed to escape slavery, comprised a tiny minority of the slave population; they were extraordinary people who were usually skilled, resourceful, and possessed a significant degree of knowledge."), _c('a', {
    attrs: {
      "id": "rinten52"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Exaggeration is another problem in autobiographies—to portray themselves more heroically, people are prone to exaggerate the difficulties they faced."), _c('a', {
    attrs: {
      "id": "rinten53"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Moreover, critics have argued that accounts published in the antebellum period were edited by abolitionists who did not hesitate to exclude or exaggerate certain information in order to further the abolitionist cause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the autobiographies of formerly enslaved people are invaluable sources for historians of slavery because, like the WPA narratives, they provide rich firsthand accounts of slavery from the perspective of enslaved people. The slave autobiographies permit us access into the private world of enslaved people, taking the reader to conversations that took place within the slave cabin."), _c('a', {
    attrs: {
      "id": "rinten54"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Indeed, because the slave autobiographies are subjective and there is extensive ego involvement throughout the accounts, they are invaluable for studies of slave self-perception. These works reveal how enslaved people felt about slavery—their anxieties, aspirations, loves, dreams, and frustrations."), _c('a', {
    attrs: {
      "id": "rinten55"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" John Blassingame has defended the slave autobiographies from accusations that they are rife with exaggeration from interfering abolitionists. Normally, he asserts, the editors of antebellum narratives were “an impressive group of people noted for their integrity.”"), _c('a', {
    attrs: {
      "id": "rinten56"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Most of the editors included professionals, such as lawyers, teachers, and scientists, who were apt at applying rules of evidence, and separating fact from fiction. In fact, most of these editors, according to Blassingame, had little to do with abolitionism.")]), _c('a', {
    attrs: {
      "id": "rinten57"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" The slave autobiographies also provide the reader with important information documenting the everyday life of common field slaves. Charles Ball’s account, the longest published slave narrative, describes, in rich detail, the daily routines of typical field slaves—what they ate, their work patterns, and what crops they grew. Ball’s account also provides detailed knowledge of the landscape and buildings that existed on the plantation where he was enslaved in South Carolina. In fact, Ball’s descriptions have been corroborated by scholars."), _c('a', {
    attrs: {
      "id": "rinten58"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Used in this way, the narratives are not wholly restricted to egotistical accounts of exceptional, literate, “unrepresentative” slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book also utilizes slave folklore. Folklorist William R. Bascom argued that there are four main functions of folklore, all of them serving to maintain the stability of culture: to entertain and allow one to escape in fantasy, validate culture, educate, and ensure conformity to the accepted cultural norms."), _c('a', {
    attrs: {
      "id": "rinten59"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Accordingly, for the historian of slavery, folklore is an excellent source from which to examine the values, morals, and attitudes of the enslaved. Indeed, folklore has been employed as a historical source in studies of slavery ever since the revisionist historians of the 1970s pioneered the use of African American sources, such as the WPA narratives and slave autobiographies."), _c('a', {
    attrs: {
      "id": "rinten60"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Through their folklore, enslaved people created a “sacred world” free from the control of their masters."), _c('a', {
    attrs: {
      "id": "rinten61"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Here, they resisted the owners’ attempts to dehumanize them, affirming their own culture. Their folklore articulated how to survive slavery, resist, conduct courtships, and generally behave. As Sterling Stuckey has argued, through folklore enslaved people “affirmed their humanity” and fashioned a “life style and set of values—an ethos” that contradicted the white racist discourses which sought to define them."), _c('a', {
    attrs: {
      "id": "rinten62"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interviewees for the WPA narratives fondly recalled slavery-era folktales. “The tales told in slavery time are unequaled. They told tales of animals and dey doings,” commented former slave Henry Warfield before he proceeded to relay a tale about Brer Guinea and Brer Rabbit."), _c('a', {
    attrs: {
      "id": "rinten63"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Former slave Sabe Rutledge stated that his mother spun cotton in the evenings and told Brer Rabbit tales to him and his siblings as they crouched down by the fire picking seeds out of cotton. Rutledge recalled, “I ’member all them Buh Rabbit story! Mudder tell ’em and we laugh.” Rutledge then told from "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("memory a tale involving “Buh Rabbit and Buh Patridge.”")]), _c('a', {
    attrs: {
      "id": "rinten64"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Like Rutledge, many other former slaves mentioned that folktales were passed down to each generation by fathers, mothers, and “de ole plantation mammies.”"), _c('a', {
    attrs: {
      "id": "rinten65"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('i', [_vm._v("My Brother Slaves")]), _vm._v(" examines a variety of folklore collections, particularly those gathered by Charles Colcock Jones Jr. and published as "), _c('i', [_vm._v("Negro Myths of the Georgia Coast")]), _vm._v(" in 1888. Jones was born in 1831, in Savannah, Georgia, where he eventually served as mayor. His family had owned more than a hundred slaves who worked rice and Sea Island cotton along the Newport River in Liberty County. Although trained as a lawyer, Jones had an academic interest in preserving folklore, and his interest in Native American relics led to his election as the first president of the American Anthropological Association, publishing "), _c('i', [_vm._v("Antiquities of the Southern Indians, Particularly of the Georgia Tribes")]), _vm._v(" in 1873. Concerned that African American folklore was in danger of vanishing, Jones spent five years collecting it along the Georgia coast, where his family members had their plantations. Unlike Joel Chandler Harris, who invented the Uncle Remus character to serve as a mouthpiece through which to narrate the Brer Rabbit tales, Jones provided the barest of introductions, instead choosing to let African Americans tell their own stories."), _c('a', {
    attrs: {
      "id": "rinten66"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Although Jones’s tales are relayed in Gullah dialect, which at times can be extremely challenging to read, they are immensely rewarding and authentic historical sources of African American folklore, offering the historian an indispensable insight into slave culture."), _c('a', {
    attrs: {
      "id": "rinten67"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Because reliable and systematic collection of African American folklore commenced only after the Civil War, some historians, such as Kenneth Stampp, have doubted whether these collections were “true expressions” of the enslaved."), _c('a', {
    attrs: {
      "id": "rinten68"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" However, since the 1970s, when revisionist historians used such collections in their works and broke new ground, attitudes have changed. Scholars maintain that postbellum African American animal stories, as well as dancing and music, can be extended “well back into slavery-time” showing “no significant change.”"), _c('a', {
    attrs: {
      "id": "rinten69"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" For example, historian Gilbert Osofsky concluded that much of the tone of the late-nineteenth- and twentieth-century collections of African American folklore repeated the wit of the antebellum slave narratives. For him, these collections seemed to supplement, rather than call into question, the authenticity of the slave narrative material, continuing a centuries-old African American oral tradition."), _c('a', {
    attrs: {
      "id": "rinten70"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("My Brother Slaves")]), _vm._v(" makes extensive use of these rich African American sources—slave autobiographies, oral narratives, and folklore—to probe the emotional and secret lives of enslaved men. It also draws on a wide variety "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("of white sources. Plantation records—accounts, diaries, and letters—are essential sources for historians of slavery. These document the rhythms of plantation operation and management; they detail daily labor routines, as well as instances of punishment and resistance; and furthermore, they chronicle the racial attitudes of antebellum white southerners, master-slave relationships, and the worldview of slave owners. Petitions are similarly revealing. A significant number of southerners (both black and white) submitted petitions to their legislatures for redress of grievances during the antebellum period; many of these concern issues of race and slavery, dealing with topics such as manumission, laws governing slavery, and miscegenation. They reveal the fears and preoccupations of antebellum white society, the grim realities of slavery, and the desires of enslaved people to gain their freedom.")]), _c('a', {
    attrs: {
      "id": "rinten71"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Newspapers and trial records of enslaved people are equally useful. Together, these sources reveal much about the social, economic, and cultural world of the antebellum South.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("My Brother Slaves")]), _vm._v(" draws on works by a range of sociologists and anthropologists to interpret the behavior and actions of enslaved men. These are valuable because they often help decode the rituals of masculinity across time and space, such as rites of passage, risk-taking behavior, and fighting. Anthropological studies of traditional West African communities, for example, are particularly useful for understanding the community-forming rituals of plantation wrestling among enslaved men in the antebellum South. These matches were, in many cases, African-derived cultural activities inherently connected to masculinity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book examines the lives of enslaved men throughout the antebellum South—from the slaveholding border states, down to the Lowcountry and Deep South, and across to the southwestern slaveholding states such as Texas. Although the rhythms of enslaved life varied according to region, crop, and size of plantation, many enslaved men throughout the antebellum South responded to their enslavement in markedly similar ways. Issues of masculinity, friendship, and resistance were generally uniform across the South; many men, whether enslaved in Maryland or Texas, drank, gambled, wrestled, hunted, evaded the patrol gangs, stole, forged friendships, and resisted their enslavement. As Stephanie Camp has argued, “for all of the important variations attributed to crop, region, and local demographics, American slavery was, above all, a system of economic exploitation, racial formation, and racial domination that, when studied in a broad geographic range, reveals strong continuities as well as differences.”"), _c('a', {
    attrs: {
      "id": "rinten72"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#inten72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" The years covered "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("by this study mostly fall in the late antebellum period—between approximately 1830 and the outbreak of the Civil War.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Overview of Chapters")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('i', [_vm._v("My Brother Slaves")]), _vm._v(" is arranged thematically. ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" analyzes the work of enslaved men. Throughout the South, on large plantations, in industry, and in skilled work, enslaved men often worked in distinctly homosocial spaces. Owners of large plantations tended to divide their enslaved workforces into sex-segregated gangs; male workers ran the labor-intensive industries of the South—the coal mines, ironworks, and lumber industries—and enslaved men occupied most skilled positions. The chapter argues that enslaved men fashioned their own masculine work culture and, where evidence permits, suggests that a strong sense of solidarity characterized their everyday working relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" explores the leisure time of enslaved men. Men not only spent this time with their families and loved ones, they socialized with other men by drinking, gambling, and wrestling. In these spaces, men reinforced certain gender, age, and status roles and fostered homosocial solidarity and reaffirmed friendships. Slaveholding mastery in the antebellum South depended on the domination and control of the slave body. By drinking and wrestling, enslaved men challenged the hegemony of the slave owner. In the process, they reclaimed their bodies from the exigencies of slavery. The chapter emphasizes how the male slave body served as a profoundly personal and political site of resistance. "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" examines how enslaved men challenged and transgressed the spatial and temporal constraints imposed by slaveholders. Enslaved men left the plantation behind when they hunted, evaded the patrol gangs, and engaged in cross-plantation theft. Crossing into illicit territory was extremely dangerous, and enslaved men often took part in these activities in the presence of other men. In these hazardous spaces, they tested one another, proved themselves to their peers, and established distinct male roles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" investigates one of the most intimate areas of life for enslaved men: male friendship. These relationships played central roles in men’s everyday lives; friendship offered vital emotional and practical support to resist the dehumanizing features of slavery. The chapter exposes how the private world of friendship instigated and nurtured a culture oppositional to enslavement. Narratives demonstrate how male friendship was pivotal in "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("effecting successful escapes to freedom in the North. Trusted friends plotted with one another, exchanged illicit information, and supported each other materially and emotionally before and during an escape. Many men risked their lives for their friends. Slaveholders tightly regulated enslaved people’s access to the outside world; however, as ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(" demonstrates, despite their best efforts, owners failed to prevent the operation of an illicit “grapevine telegraph”—a network that spread news and correspondence between enslaved communities maintained by mobile bondpeople. Enslaved men were key players in this illicit network; their mobility presented them with more opportunities than their female counterparts to acquire geographical knowledge and make contact with abolitionist sources. This chapter unravels the secret operations of this network: through this system of communication, enslaved men exchanged subversive ideas as well as daily news. Indeed, evidence shows that men used the grapevine telegraph to forge an inter-plantation network with other men and hold conspiratorial meetings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("My Brother Slaves")]), _vm._v(" studies the relationships shared between enslaved men and emphasizes that their lives were intertwined. On plantations across the South, they created an all-male subculture through which they constructed their own independent notions of masculinity, friendship, and resistance. Homosocial company was integral to the gendered identity and self-esteem of enslaved men. The emotional landscape they created together offered them a vital mutual support network through which to resist the horrors of slavery. Through each other, enslaved men created a secret world that defied and subverted the slaveholder’s authority.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13383504","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Introduction.vue
// module id = 75
// module chunks = 0